import Classic from './Classic/Classic';
import Royal from './Royal/Royal';
import Parchment from './Parchment/Parchment';
import Elegant from './Elegant/Elegant';
import Modern from './Modern/Modern';
import Columns from './Columns/Columns';
import Ribbon from './Ribbon/Ribbon';
import Banner from './Banner/Banner';

const templates = {
  Classic,
  Royal,
  Parchment,
  Elegant,
  Modern,
  Columns,
  Ribbon,
  Banner,
};

export default templates;
